import { Link } from "react-router-dom";

export default function UnderConstruction() {
  return (
    <div className="page-navbar-space container">
      <div className="d-flex align-items-center justify-content-center flex-column my-5 py-5">
        <h1 className="display-1 fw-bold text-warning text-center">Under Construction</h1>
        <p className="lead text-muted text-center fw-medium">
          We are working hard to bring this feature to you. Please check back later. <br />
          Thank you for your patience.
        </p>
        <Link to="/" className="btn btn-primary  btn-lg mt-4">
          Go Home
        </Link>
      </div>
    </div>
  )
}
